/**
 * Reconcilieer de betaalstatus van een Werk_Order direct vanuit Mollie. Boekt
 * de ontbrekende Transactie__c als de klant wél betaald heeft maar de webhook
 * niet binnenkwam — vangnet dat sneller is dan de 4-uurs sync-batch.
 */

import { supabase } from './supabase';

async function authHeader(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface SyncMollieResult {
  ok: boolean;
  /** Is er bij Mollie een betaalde link gevonden? */
  paymentFound?: boolean;
  volledigBetaald?: boolean;
  openstaandBedrag?: number;
  molliePaymentStatus?: string;
  werkOrderNummer?: string;
  werkOrderLastModifiedDate?: string;
  error?: string;
  code?: string;
}

export async function syncOrderFromMollie(orderId: string): Promise<SyncMollieResult> {
  const headers = await authHeader();
  const res = await fetch('/api/orders/sync-mollie', {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderId }),
  });
  const data = (await res.json()) as SyncMollieResult;
  return { ...data, ok: res.ok && data.ok !== false };
}
